module.exports = __webpack_public_path__ + "static/media/red-blue.1c3e1f43.png";